var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networksQuality"},[_c('span',{staticClass:"level1",class:_vm.bgColor}),_c('span',{staticClass:"level2",class:_vm.bgColor}),_c('span',{staticClass:"level3",class:_vm.bgColor})])
}
var staticRenderFns = []

export { render, staticRenderFns }